import { fontStyleHeadings2 } from "components/Common/styles.js";

export const commonPageStyle = {
  commonSummaryHeadingContainer: {
    default: {
      padding: "30px 0px 30px 15px",
    },
    retro: {
      padding: "30px 0px 0px 15px",
    }, electric: {
      padding: "30px 0px 0px 15px",
    },
  },
  commonSummarySetupHeadingContainer: {
    default: {
      padding: "0px 0px 30px 15px",
    },
    retro: {
      padding: "0px 0px 0px 15px",
    },
    electric: {
      padding: "0px 0px 0px 15px",
    },
  },

  commonSummaryHeadingStyle: fontStyleHeadings2,
};



// WEBPACK FOOTER //
// ./src/components/Common/Summary/styles/CommonPageStyle.js